export default (date) => (
  new Date(date).toLocaleDateString(document.documentElement.lang, {
    year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC',
  })
);
